




























import { Component, Vue } from 'vue-property-decorator';
import { MUNICIPALITY_SELECTIONS } from './municipalitySelections';
import MunicipalitySelectionDeleteButton from '@/components/Municipality/MunicipalitySelectionDeleteButton.vue';
import MunicipalitySelectionShowButton from '@/components/Municipality/MunicipalitySelectionShowButton.vue';

@Component({
  components: {
    MunicipalitySelectionDeleteButton,
    MunicipalitySelectionShowButton,
  },
})
export default class MunicipalitySelectionList extends Vue {
  private MUNICIPALITY_SELECTIONS = MUNICIPALITY_SELECTIONS;
}
